<template>
  <CContainer class="mt-3 bg-white-251" fluid>
    <CTabs :fade="false" class="py-2" color="primary">
      <CTab class="mt-2" v-for="(aiMenu, key) in listAIMenu" :key="key" :title="aiMenu.api_name">
        <CCard>
          <CCardBody>
            <CRow>
              <CCol lg="5">
                <label>Description :</label>
                <p>{{aiMenu.description}}</p>
              </CCol>
            </CRow>
            <CRow>
              <CCol lg="5">
                <label>Endpoint :</label>
                <p><a :href="aiMenu.endpoint" target="_blank">{{aiMenu.endpoint}}</a></p>
              </CCol>
            </CRow> 
          </CCardBody>
        </CCard>
        <CRow>
          <CCol>
            <CCard>
              <CCardHeader>
                <div class="header-text">
                  <h5>Request (POST)</h5>
                </div>
              </CCardHeader>
              <CCardBody>
                <label>Data Type :</label>
                <CInput
                  v-model="aiMenu.request.data_type"
                  readonly
                  class="ffm-lucida"
                />
                <label>Content :</label>
                <div class="p-3 mb-3 disabled-container">
                  <pre class="pre-black ffm-lucida">{{convertJson(aiMenu.request.content)}}</pre>
                </div>
                <CRow>
                  <CCol>
                    <label>Variables :</label>
                    <CDataTable
                      :items="aiMenu.request.variables"
                    >
                      <template #required="{item}">
                        <td>
                          <CBadge :color="getBadge(item.required)">
                            {{item.required}}
                          </CBadge>
                        </td>
                      </template>
                    </CDataTable>
                  </CCol>
                </CRow>
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <CCard>
              <CCardHeader color="info">
                <div class="header-text">
                  <h5>Responses</h5>
                </div>
              </CCardHeader>
              <CCardBody>
                <CRow>
                  <CCol>
                    <CTabs :fade="false" class="py-2" color="primary">
                      <CTab class="mt-2" v-for="(response, keyResponse) in aiMenu.responses" :key="keyResponse" :title="response.description">
                        <label>Data Type :</label>
                        <CInput
                          v-model="response.data_type"
                          readonly
                          class="ffm-lucida"
                        />
                        <label>Content :</label>
                        <div class="p-3 disabled-container">
                          <p class="pre-black pre-wrap ffm-lucida">
                             {{response.content}}
                          </p>
                        </div>
                      </CTab>
                    </CTabs>
                  </CCol>
                </CRow>
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
      </CTab>
    </CTabs>
    <CModal
      color="primary"
      :show.sync="showErrorModal" :centered="true">
      <div slot="header"><h5>{{modalTitle}}</h5></div>
      <div class="">
        {{errorLabel}}
      </div>
      <div slot="footer">
        <CButton color="primary" @click="showErrorModal = false">OK</CButton>
      </div>
    </CModal>
  </CContainer>
</template>

<script>
export default {
  name: 'Documentation',
  data(){
    return {
      showErrorModal: false,
      errorLabel: 'Error occured.',
      modalTitle: 'Error System!',
      listAIMenu: [],
    }
  },
  methods: {
    convertJson(string){
      let lastIndex = string.lastIndexOf('}');
      let stringKoma = string.charAt(lastIndex - 1);
      if(stringKoma === ','){
        string = string.replace(",}", '}');
      }
      return JSON.parse(string);
    },
    getDocumentation(){
      this.$store.commit('set', ['isLoading', true]);
      let processUrl = 'api/backend/v2/documentation';
      return this.$axios.get(processUrl)
      .then((response) => {
        if(response.status == 200){
          if(response.data.success){
            this.listAIMenu = response.data.data;
            for (const menu of this.listAIMenu) {
              for (var itemResponse of menu.responses) {
                itemResponse.content = JSON.parse(itemResponse.content);
              }
            }
            this.$store.commit('set', ['isLoading', false]);
          } else {
            this.modalTitle = 'Failed Fetch Documentation';
            this.errorLabel = response.data.message;
            this.$store.commit('set', ['isLoading', false]);
            this.showErrorModal = true;
          }
        } else {
          this.errorAction(response);
        }
      })
      .catch((err) => {
        this.errorAction(err);
      })
    },
    getBadge(required){
      switch (required) {
        case true: return 'danger'
        case false: return 'info'
        default: 'primary'
      }
    },
    errorAction(error){
      let listError = this.$helper.errorHandling(error);
      this.modalTitle = this.$errorLabel.generic;
      this.errorLabel = 'Terjadi kesalahan: '+listError[0] || 'Unknown Error';
      this.$store.commit('set', ['isLoading', false]);
      this.showErrorModal = true;
    }
  },
  async created(){
    await this.getDocumentation()
  }
}
</script>

<style>
.black-color-div{
  background-color: black;
}
</style>